import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_VS,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const CausesCondictionsChartsDataContext = createContext();

const CausesCondictionsChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_VS.CONDITIONS_CAUSES_MORTALITY,
            url: 'governanceroom/dashboard/vitalstatistics/mortality/conditions-causes',
        },
        {
            data_inicio: filters.data_inicio,
            data_fim: filters.data_fim,
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              puerperiumDeath: data?.puerperiumDeath ?? [],
              medicalAssistance: data?.medicalAssistance ?? [],
              cirurgyConfirmation: data?.cirurgyConfirmation ?? [],
              confirmationByComplementaryExamination:
                  data?.confirmationByComplementaryExamination ?? [],
              confirmationByNecropsy: data?.confirmationByNecropsy ?? [],
          }
        : {
              puerperiumDeath: [],
              medicalAssistance: [],
              cirurgyConfirmation: [],
              confirmationByComplementaryExamination: [],
              confirmationByNecropsy: [],
          };

    return (
        <CausesCondictionsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </CausesCondictionsChartsDataContext.Provider>
    );
};

export default CausesCondictionsChartsDataProvider;
